import React, { useEffect, useState } from 'react';

const ConfettiAnimation = ({ trigger, duration = 3500 }) => {
  const [isActive, setIsActive] = useState(false);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (trigger) {
      setIsActive(true);
      createParticles();
      
      const timer = setTimeout(() => {
        setIsActive(false);
        setParticles([]);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [trigger, duration]);

  const createParticles = () => {
    const newParticles = [];
    const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD', '#98D8C8', '#FF9F43', '#10B981', '#F59E0B'];
    const emojis = ['🎉', '🎊', '✨', '🎈', '🎯', '🏆', '💫', '⭐', '🌟', '💎', '🧡'];
    
    for (let i = 0; i < 70; i++) {
      newParticles.push({
        id: i,
        x: Math.random() * window.innerWidth,
        y: -30,
        vx: (Math.random() - 0.5) * 8,
        vy: Math.random() * 3.5 + 2.5,
        rotation: Math.random() * 360,
        rotationSpeed: (Math.random() - 0.5) * 12,
        color: colors[Math.floor(Math.random() * colors.length)],
        emoji: emojis[Math.floor(Math.random() * emojis.length)],
        size: Math.random() * 22 + 12,
        opacity: 1,
        type: Math.random() > 0.5 ? 'emoji' : 'confetti'
      });
    }
    setParticles(newParticles);
  };

  useEffect(() => {
    if (!isActive) return;

    const interval = setInterval(() => {
      setParticles(prevParticles => 
        prevParticles.map(particle => ({
          ...particle,
          x: particle.x + particle.vx,
          y: particle.y + particle.vy,
          rotation: particle.rotation + particle.rotationSpeed,
          opacity: particle.opacity - 0.015,
          vy: particle.vy + 0.12 // gravity
        })).filter(particle => particle.opacity > 0)
      );
    }, 45);

    return () => clearInterval(interval);
  }, [isActive]);

  if (!isActive) return null;

  return (
    <div 
      className="fixed inset-0 pointer-events-none overflow-hidden" 
      style={{ zIndex: 99999999, pointerEvents: 'none' }}
    >
      {particles.map(particle => (
        <div
          key={particle.id}
          className="absolute select-none pointer-events-none"
          style={{
            left: particle.x,
            top: particle.y,
            transform: `rotate(${particle.rotation}deg)`,
            opacity: particle.opacity,
            fontSize: `${particle.size}px`,
            color: particle.color,
            transition: 'all 0.05s ease-out'
          }}
        >
          {particle.type === 'emoji' ? (
            <span className="select-none filter drop-shadow">{particle.emoji}</span>
          ) : (
            <div
              className="rounded-full shadow-md"
              style={{
                backgroundColor: particle.color,
                width: `${particle.size}px`,
                height: `${particle.size}px`
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ConfettiAnimation;